import { SHOPIFY_ACTIONS } from "../constants";
import { stringToBase64 } from "../shared/utility";
import {
  deleteRequestWithData,
  getRequest,
  postRequest,
  putRequest,
} from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";

//------- Get Shopify Presets
const getShopifyPresets = (storeId) => {
  return getRequest(`shopify-setting/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------- Get Shopify Presets by id
const getShopifyMappingsById = (storeId, id) => {
  return getRequest(`shopify-setting/${storeId}/${id}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------ Create Shopify Presets
const createShopifyPreset = (storeId, data) => {
  return postRequest(`shopify-setting/${storeId}`, data, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------ Create Shopify Presets
const createProductMappingObject = (storeId, data) => {
  return postRequest(
    `shopify-setting/${storeId}?isShopifySettingImage=true`,
    data,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------ Create Shopify Presets
const updateShopifyPreset = (storeId, data) => {
  return putRequest(`shopify-setting/${storeId}`, data, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------ Delete Shopify Presets
const deleteShopifyPreset = (storeId, data) => {
  return deleteRequestWithData(`shopify-setting/${storeId}`, data, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------ Get Shopify Orders
const getShopifyOrders = (storeId, gridState) => {
  return getRequest(
    `shopify-order/${storeId}?search=${gridState.searchQuery}&pageNumber=${
      gridState.pageIndex
    }&pageSize=${gridState.pageSize}&filters=${stringToBase64(
      gridState.filters
    )}&sortFilter=${stringToBase64(gridState.sortFilter)}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateShopifyOrderStatus = (storeId, data) => {
  return putRequest(
    `shopify-order/${storeId}/${data?.id}?orderUpdateType=orderStatusUpdate`,
    data,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateShopifyOrderCustomer = (storeId, data) => {
  return putRequest(
    `shopify-order/${storeId}/${data?.id}?orderUpdateType=orderCustomerUpdate`,
    data,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------- Get Shopify Product tags
const getShopifyProductTags = (storeId) => {
  return getRequest(`shopify-product-tags/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------- Get Shopify Theme Templates
const getShopifyThemeTemplates = (storeId) => {
  return getRequest(`shopify-theme-templates/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getShopifyOrderById = (storeId, orderId) => {
  return getRequest(`shopify-order/${storeId}/${orderId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getMultiplyShopifyOrdersById = (storeId, ids) => {
  return getRequest(`shopify-order/${storeId}/${ids}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//------- Update inventory presets to defaults
const updateInventoryPresetsToDefault = (storeId) => {
  return putRequest(
    `shopify?type=TRIGGER_UPDATE_INVENTORY_PRESETS_TO_DEFAULT&storeId=${storeId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const connectShopify = (data) => {
  return getRequest(
    `shopify?shop=${data.shop}&companyId=${data.companyId}&storeId=${data.storeId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const connectShopifyAccessTokenFromStoreMiscDataToStore = (data) => {
  return getRequest(
    `shopify?type=SAVE_SHOPIFY_INSTALL_ACCESS_TOKEN&storeId=${data.storeId}&companyId=${data.companyId}&shopifyAppInstallStoreMiscDataId=${data.shopifyAppInstallStoreMiscDataId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const triggerCustomerSyncWithShopify = (data) => {
  return putRequest(
    `shopify?type=TRIGGER_CUSTOMER_SYNC&storeId=${data.storeId}`,
    {},
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getEligibleShopifyLocations = (companyId) => {
  return getRequest(
    `shopify?type=${SHOPIFY_ACTIONS.GET_ELIGIBLE_LOCATIONS}&companyId=${companyId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const assignExistingShopifyLocation = (storeId, locationId) => {
  return putRequest(
    `shopify?type=${SHOPIFY_ACTIONS.ASSIGN_EXISTING_LOCATION}&storeId=${storeId}`,
    { locationId },
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const createShopifyLocation = (storeId) => {
  return putRequest(
    `shopify?type=${SHOPIFY_ACTIONS.CREATE_LOCATION}&storeId=${storeId}`,
    {},
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Export Shopify Services
export const shopifyService = {
  getShopifyOrders,
  getShopifyPresets,
  getShopifyOrderById,
  createShopifyPreset,
  updateShopifyPreset,
  deleteShopifyPreset,
  getShopifyProductTags,
  getShopifyMappingsById,
  updateShopifyOrderStatus,
  getShopifyThemeTemplates,
  createProductMappingObject,
  updateShopifyOrderCustomer,
  getMultiplyShopifyOrdersById,
  updateInventoryPresetsToDefault,
  connectShopify,
  connectShopifyAccessTokenFromStoreMiscDataToStore,
  triggerCustomerSyncWithShopify,
  getEligibleShopifyLocations,
  assignExistingShopifyLocation,
  createShopifyLocation,
};
